import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function savePreset(payload) {
  const { data } = await axios.post(`${API}/presets`, payload);
  return data;
}
export async function listPresets() {
  const { data } = await axios.get(`${API}/presets`);
  return data;
}
export async function getPreset(id) {
  const { data } = await axios.get(`${API}/presets/${id}`);
  return data;
}
export async function deletePreset(id) {
  await axios.delete(`${API}/presets/${id}`);
}
